import { render, staticRenderFns } from "./DossierScriptEditUpload.vue?vue&type=template&id=047ae606&"
import script from "./DossierScriptEditUpload.vue?vue&type=script&lang=ts&"
export * from "./DossierScriptEditUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047ae606')) {
      api.createRecord('047ae606', component.options)
    } else {
      api.reload('047ae606', component.options)
    }
    module.hot.accept("./DossierScriptEditUpload.vue?vue&type=template&id=047ae606&", function () {
      api.rerender('047ae606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierScriptEditUpload.vue"
export default component.exports